import {SoopAvatarCommon, SoopIcon, SoopLayer} from '@soop-ui/soop-ui';
import styles from './Subscription.module.scss';
import TextEllipsis from '@/components/channel/common/TextEllipsis';
import clsx from 'clsx';
import useStationSubscriptionListQuery from '@/query/channel/menu/useStationSubscriptionGiftQuery';
import {useEffect, useRef} from 'react';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';
import globalDomains from '@/utils/global-domains';
import ChannelIctWrapper from '@/components/channel/common/ChannelIctWrapper';
import {getUserLoginId} from '@/utils/main';

interface SubscriptionLayerProps {
  isCollapse?: boolean;
  streamerId: string;
  onClose: () => void;
  style?: React.CSSProperties;
  type: 'acc' | 'gift';
}

const TopsubscriptionLayer = ({
  isCollapse = false,
  streamerId,
  type,
  onClose,
  style,
}: SubscriptionLayerProps) => {
  const {data: subscriptionGiftList, refetch} = useStationSubscriptionListQuery(
    {
      streamerId,
    },
    type,
  );

  useEffect(() => {
    if (!subscriptionGiftList) {
      refetch();
    }
  }, [subscriptionGiftList]);

  const layerRef = useRef<HTMLDivElement>(null);
  useOutsideClick(layerRef, onClose);

  const handleHomeClick = (userId: string) => {
    window.open(`${globalDomains.WWW_AFREECATV}/station/${userId}`, '_blank');
  };

  if (!subscriptionGiftList) {
    return null;
  }

  return (
    <SoopLayer
      size='lg'
      onClose={onClose}
      className={clsx(styles.giftRankLayer, isCollapse && styles.collapse)}
      style={style}>
      <div ref={layerRef}>
        <SoopLayer.Header>
          {type === 'acc' ? '구독팬' : '구독 선물'}
        </SoopLayer.Header>
        <SoopLayer.Content>
          <div className={styles.rankList}>
            <ul
              className={clsx(subscriptionGiftList.length === 2 && styles.two)}>
              {subscriptionGiftList.map((subscription, index) => (
                <li key={index}>
                  <div className={styles.authorWrapper}>
                    <div className={styles.author}>
                      <SoopAvatarCommon
                        mode='button'
                        onClick={() => handleHomeClick(subscription.userId)}
                        size={24}
                        userId={subscription.userId}
                        variant='default'
                        forceUpdate={getUserLoginId() === subscription.userId}
                      />
                      {index <= 1 ? (
                        <SoopIcon
                          name={
                            index === 0
                              ? 'icoSupportRank1'
                              : index === 1
                                ? 'icoSupportRank2'
                                : 'icoSupportRank3'
                          }
                          inheritColors={false}
                          className={styles.icon}
                          width={'16px'}
                          height={'16px'}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                    <button type='button' className={styles.nick}>
                      <ChannelIctWrapper
                        userId={subscription.userId}
                        style={{zIndex: 2000}}>
                        <TextEllipsis as='span' line={1}>
                          {subscription.userNickname}
                        </TextEllipsis>
                      </ChannelIctWrapper>
                    </button>
                  </div>
                  <span
                    className={clsx(
                      styles.badge,
                      index <= 4 && styles['topfan'],
                    )}>
                    {`${index + 1}등`}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </SoopLayer.Content>
      </div>
    </SoopLayer>
  );
};

export default TopsubscriptionLayer;
